import { Alert, Avatar, Button, InputNumber, Modal, Space, Typography } from 'antd'
import React, { useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';


const { Title, Text } = Typography;

const colors = {
    primary: '#242166',
    secondary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    info: '#13c2c2',
    light: '#f0f2f5',
    gradient1: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
    gradient2: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    gradient3: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    gradient4: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
};

const TauxCommissionsIntermediaireDefinition = ({ categories, manageTauxOpen, setManageTauxOpen, intermediaire, setReload, commissionValues, setCommissionValues, canEditRates = true }) => {

    const [savingTaux, setSavingTaux] = useState(false);

    const handleSaveCommissionRates = () => {
        if (!canEditRates) {
            setManageTauxOpen(false);
            return;
        }

        if (!intermediaire?.codeIntermediaire || !categories.length) {
            return;
        }
        setSavingTaux(true);
        const requests = categories
            .filter((cat) => commissionValues[cat.codeCategorie] !== undefined)
            .map((cat) =>
                axiosInstance.get(
                    `/api/intermediaire/update-tc/${intermediaire.codeIntermediaire}/${cat.codeCategorie}/${commissionValues[cat.codeCategorie] || 0}`
                )
            );

        Promise.all(requests)
            .then(() => {
                toast("Taux de commission mis à jour avec succès!");
                setManageTauxOpen(false);
                setReload((prev) => !prev);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSavingTaux(false);
            });
    };

    const handleCommissionValueChange = (codeCategorie, value) => {
        setCommissionValues((prev) => ({
            ...prev,
            [codeCategorie]: value ?? 0
        }));
    };

    return (
        <Modal
            open={manageTauxOpen}
            onCancel={() => setManageTauxOpen(false)}
            footer={null}
            width={720}
            centered
            destroyOnClose
        >
            <div className="text-center mb-4">
                <Title level={4} style={{ marginBottom: 0 }}>Gestion des taux de commission</Title>
                <Text type="secondary">
                    Définissez les taux de commission pour chaque catégorie d'assurance de{' '}
                    <b>{intermediaire?.organisme?.raisonSociale || intermediaire?.personne?.nom}</b>
                </Text>
            </div>

            <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: 8 }}>
                {categories.map((cat) => (
                    <div
                        key={cat.codeCategorie}
                        style={{
                            border: '1px solid #f0f0f0',
                            borderRadius: 12,
                            padding: 16,
                            marginBottom: 12,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Space align="start">
                            <Avatar shape="square" size={40} style={{ background: colors.light, color: colors.primary }}>
                                {cat.codeCategorie?.charAt(0)}
                            </Avatar>
                            <div>
                                <Text strong>{cat.nom}</Text>
                                <div>
                                    <Text type="secondary">{cat.codeCategorie}</Text>
                                </div>
                            </div>
                        </Space>
                        <Space>
                            <InputNumber
                                min={0}
                                precision={2}
                                value={commissionValues[cat.codeCategorie] ?? 0}
                                disabled={!canEditRates}
                                onChange={(value) => handleCommissionValueChange(cat.codeCategorie, value)}
                                style={{ width: 120 }}
                            />
                            <Text strong>%</Text>
                        </Space>
                    </div>
                ))}
            </div>

            <Alert
                type="info"
                showIcon
                message={canEditRates ? "Les modifications seront appliquées immédiatement après enregistrement." : "Mode lecture seule : les taux sont visibles mais non modifiables."}
                style={{ marginTop: 16 }}
            />

            <Space style={{ width: '100%', justifyContent: 'flex-end', marginTop: 16 }}>
                <Button onClick={() => setManageTauxOpen(false)}>{canEditRates ? 'Annuler' : 'Fermer'}</Button>
                {canEditRates && (
                    <Button type="primary" onClick={handleSaveCommissionRates} loading={savingTaux}>
                        Enregistrer les taux
                    </Button>
                )}
            </Space>
        </Modal>
    )
}

export default TauxCommissionsIntermediaireDefinition
